import { useStore } from '@nanostores/react'
import { campaignApi, CampaignsUI } from 'features/campaigns/index.ts'
import { notificationHooks } from 'features/notifications/index.ts'
import { atom } from 'nanostores'
import { useNavigate } from 'react-router-dom'

const $isOpen = atom(false)
const closeModal = () => $isOpen.set(false)
Creating.open = () => $isOpen.set(true)
export function Creating() {
	const isOpen = useStore($isOpen)

	const snack = notificationHooks.useSnack()
	const [create, { isLoading }] = campaignApi.useCreateCampaignMutation()
	const navigate = useNavigate()

	return (
		<CampaignsUI.CreateModal
			isLoading={isLoading}
			onRequestClose={closeModal}
			onSubmit={async name => {
				const { data: campaign } = await create(name)

				if (!campaign) {
					return
				}

				snack('3.1')
				closeModal()
				navigate(`/campaigns/${campaign.id}/tune`)
			}}
			open={isOpen}
		/>
	)
}
